'use strict';

import { updateHistoryState, getQueryStringParams, appendParamsToURL } from '../helpers/urlUtilities';
import { publishEvent, initMethods, initModules, addEventListenerList } from '../helpers/utilities';
import * as progress from '../components/progress';
import { callbackOnElements, createCookie, readCookie } from '@borngroup/born-utilities';
import { setupInfiniteScroll, getNextPageNumber, updatePageHistory } from '../modules/module.infinite-scroll';
import { IEImageSupport } from '../helpers/polyfills.js';
import { widget3DConfiguration } from '../product/widget3D';
import {getOptions} from '../product/productUtils';
import { searchResultNavActive, sliderSearchNav } from '../components/search.js';
/**
 * Returns an Array containing the list of toggled refinement triggers.
 * This is then used in the template to re-toggle the same triggers.
 * @return {[type]} [description]
 */
function _getToggledRefinements() {
    let toggledRefinements = [];

    callbackOnElements('[data-search-component="refinement-trigger"]', function(currentTrigger) {
        if (currentTrigger.toggle && currentTrigger.classList.contains('refinement--active')) {
            toggledRefinements.push(currentTrigger.closest('[data-refinement-type]').getAttribute('data-refinement-type'));
        }
    });

    return toggledRefinements;
}

function _getToggledGridFeed() {
    let selectedLayout = document.querySelector('[data-search-component="grid-feed-toggle"].set--active');

    if (selectedLayout) {
        return selectedLayout.getAttribute('data-search-layout');
    }
}

function toggleHiddenRefinements() {
    addEventListenerList('[data-refinement-show-more]', 'click', function() {
        let showMore = $(this).data('refinement-show-more'),
            sibilings = $(this).parent().siblings('[data-refinement-hide]');

        if (showMore == true) {
            sibilings.removeClass('hidden');
            $(this).data('refinement-show-more', false);

            let lessText = $(this).data('less-text');
            $(this).text(lessText);
        } else {
            sibilings.addClass('hidden');
            $(this).data('refinement-show-more', true);

            let moreText = $(this).data('more-text');
            $(this).text(moreText);
        }
    });
}

/**
 * Returns TRUE if the refinement-bar is currently active (typically this only applies on mobile)
 * @return {[type]} [description]
 */
function _getRefineBarIsToggled() {
    let refineBarTrigger = document.querySelector('[data-search-component="refinement-bar-trigger"]');

    return refineBarTrigger && refineBarTrigger.toggle && refineBarTrigger.toggle.isSet;
}

function _handleRefinementTracking() {
    let refinementTrackingEl = document.querySelector('[data-refinement-tracking]');

    if (refinementTrackingEl) {
        publishEvent('actiondone', false, refinementTrackingEl);
    }
}

/**
 * Sends a Search-Results request using the `options.url` value, or from an attribute in the triggered element.
 * @param  {Object} options [description]
 * @param  {[type]} evt     [description]
 * @return {[type]}         [description]
 */
function _updateResults(options = {}, evt) {
    let requestUrl = options.url || this.getAttribute('data-url') || this.href || this.value,
        refineBarToggled = _getRefineBarIsToggled();
    let strapColorCarousel = document.querySelectorAll('[data-strap-color-carousel]');

    if (evt) {
        evt.preventDefault();
        evt.stopPropagation();
    }

    if (this instanceof HTMLElement && (this.disabled || this.classList.contains('disabled'))) {
        return false;
    }

    options.requestData = options.requestData || {};
    options.requestData.selectedUrl = requestUrl;

    //Avoid passing this parameter at all if it's empty.
    if (refineBarToggled) {
        options.requestData.refineBarToggled = refineBarToggled;
    }

    options.requestData.toggledRefinements = _getToggledRefinements();

    requestUrl = appendParamsToURL(requestUrl, { 'toggleGridFeed': _getToggledGridFeed() });

    if (options.event && options.target) {
        publishEvent('search', options.event, options.target);
    }

    progress.showLoader(options.loadingContainer);

    return $.get(
        requestUrl,
        options.requestData,
        function(response) {
            if (options.updateHTML) {
                $(options.target).html(response);
            } else if (options.appendHTML) {
                $(options.target).append(response);
            } else {
                $(options.target).replaceWith(response);
            }

            if (options.updateHistory) {
                updateHistoryState(requestUrl, '', 'pushState');
            }

            //Hax https://stackoverflow.com/questions/24148403/trigger-css-transition-on-appended-element
            document.body.offsetWidth;

            initModules();

            //Re-run the image scaling polyfills after PLP renders through AJAX.
            IEImageSupport();

            //Attempt to set the focus back to the last refinement selected, if any.
            if (options.targetFocus) {
                callbackOnElements(options.targetFocus, currentEl => currentEl.focus({ preventScroll: true }));
            }

            if (typeof options.callback === 'function') {
                options.callback(response);
            } else {
                initMethods(options.callback);
            }

            toggleHiddenRefinements();
            if (strapColorCarousel && strapColorCarousel.length > 0) {
                plpColorStrap();
                widget3DConfiguration();
            }
            resetProductAnchors();
            if (window.SFRA.SitePreferences.yotpoEnabled && window.yotpo) {
                window.yotpo.initWidgets();
            }
            searchResultNavActive();
            sliderSearchNav($('.search-results__nav'));

            progress.hideLoader();
        }
    ).then(function() {
        if (options.event === 'refine' || options.event === 'sort') {
            _handleRefinementTracking();
        }
        if (options.event === 'refine') {
            let filterChecked = document.querySelectorAll('.refinement__boolean-item [data-refinement-action]');
            filterChecked.forEach(function(filter) {
                if (filter.classList.contains('set--checked')) {
                    $('.search-results__main').addClass('filter-active');
                }
            })
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function _updateSortOptions(response) {
    let parser = new DOMParser(),
        sortOptionsEl = parser.parseFromString(response, 'text/html').querySelector('[data-sort-options]'),
        sortOptions = sortOptionsEl ? JSON.parse(sortOptionsEl.getAttribute('data-sort-options')).options : [];

    sortOptions.forEach(function(option) {
        let matchedOptionEls = document.querySelectorAll(`[data-sort-option-id="${option.id}"]`);

        [].forEach.call(matchedOptionEls, currentOptionEl => currentOptionEl.href = option.url);
    });
}

let itemArray = readCookie('item-list') ? JSON.parse(decodeURIComponent(readCookie('item-list'))) : [];

function _setItemListName(itemListid, itemListName) {
    let itemObj = {
        itemListid: itemListid,
        itemListName: itemListName
    };
    itemArray.push(itemObj);
    const newMap = new Map();
    itemArray.forEach((item) => newMap.set(item.itemListid, item));
    let newArr = [ ...newMap.values() ];
    createCookie('item-list', encodeURIComponent(JSON.stringify(newArr)));
}

function pushDataLayer(itemId) {
    let dataLayer = window.dataLayer;
    let listView = dataLayer.filter(function(index) {
        return index.event == 'eeListView' ? index : '';
    });
    if (listView.length > 0) {

        let getListName = listView[0].products[0].listName;
        _setItemListName(itemId, getListName);
    }

}

function strapStatus(isStrapUnvailable, _ev) {
    _ev.closest('.strap-bar__dailog').find('[data-product-component="add-button"]').prop('disabled', !!isStrapUnvailable);
}

export function plpColorStrap() {
    let strapCount = document.querySelectorAll('[data-strap-count]'),
        closeStrap = document.querySelectorAll('[data-close-strap]'),
        _colorStrap = document.querySelectorAll('[data-strap-plp]'),
        _colorStrapOptions = document.querySelectorAll('[data-strap-plp-options]'),
        strapName = $('.pdp-straps__item'),
        _strap,
        _parent,
        _starpVal,
        strapView,
        _parentNode,
        _this,
        starpBar;

    [].forEach.call(strapCount, currentItem => currentItem.addEventListener('click', function() {
        starpBar = $(this).parent().find('.strap-bar__dailog');
        const $strapBarDialogToClose = $(closeStrap).closest('.strap-bar__dailog');
        document.body.classList.add('strap-dialog-overlay');
        $(this).closest('.product-grid__item').addClass('index');
        $strapBarDialogToClose.removeClass('opacity');
        $(closeStrap).closest('.product-tile').removeClass('index strap-view-active');
        $(starpBar).addClass('opacity');
        $(this).closest('.product-tile').addClass('index strap-view-active');
        $(this).parent().find('.window-overlay').addClass('strap-overlay');
        $('.search-results__container').addClass('index');
        $('.pdp-straps__carousel').slick('setDimensions');

        // Remove the source of the previously open iframe to offload resources.
        const $iframeToReset = $strapBarDialogToClose.find('iframe.webgl-img');
        $iframeToReset.attr('src', 'about:blank');

        // Load iframe with 3d visualisation for the current product.
        const $iframe = starpBar.find('iframe.webgl-img');
        $iframe.attr('src', $iframe.data('src'));
        const _lastVal = starpBar.find('.toggle');
        const _active = starpBar.find('.default-active');
        $(_lastVal).removeClass('toggle--active toggle');
        $(_active).addClass('toggle--active toggle');
    }));

    [].forEach.call(closeStrap, currentItem => currentItem.addEventListener('click', function() {
        document.body.classList.remove('strap-dialog-overlay');
        $(this).closest('.product-grid__item').removeClass('index');
        $(this).closest('.strap-bar__dailog').removeClass('opacity');
        $(this).closest('.product-tile').removeClass('index strap-view-active');
        $('.window-overlay').removeClass('strap-overlay');
        $('.search-results__container').addClass('index');
    }));

    [].forEach.call(_colorStrap, currentItem => currentItem.addEventListener('click', function() {
        _starpVal = $(this).find('.starpcolor-name').text(),
        _parentNode = $(this).parents('.strap-bar__dailog').find('.strap-name'),
        _this = $(this);
        let isDefaultStrap = this.options && this.options[this.selectedIndex].getAttribute('data-default-strap') ? this.getAttribute('data-default-strap') : false;
        let dataStrapInstock = this.options ? this.options[this.selectedIndex].getAttribute('data-strap-instock') : this.getAttribute('data-strap-instock');
        let strapInstock = isDefaultStrap && isDefaultStrap === 'true' ? isDefaultStrap : dataStrapInstock;

        let isStrapUnvailable = strapInstock && strapInstock == 'false' ? true : false;
        $(_parentNode).empty();
        $(_parentNode).html(_starpVal);
        let parent = $(this).parents('[data-product-container="tile"]'),
            pid = parent ? $(parent).data('pid') : '',
            pdpLinkEle = $('[data-pdp-link-of="' + pid + '"]'),
            url = $(this).attr('href'),
            queryStringParams = getQueryStringParams(url),
            pdpLink = pdpLinkEle.attr('href'),
            options = getOptions(this);

        options.forEach(function(option) {
            let optionObj = {};
            optionObj[option.optionId] = option.selectedValueId;
            queryStringParams = Object.assign(optionObj, queryStringParams);
        });

        if (pdpLinkEle && pdpLink && queryStringParams) {
            pdpLink = pdpLink.split('?')[0];
            pdpLinkEle.attr('href', appendParamsToURL(pdpLink, queryStringParams));
        }
        if ($(this).attr('data-default-strap') == 'true') {
            pdpLinkEle.attr('href', url);

            $(_colorStrapOptions).each(function() {
                if ($(this).hasClass('toggle--active')) {
                    $(this).removeClass('toggle--active');
                }
            })
        }
        $(strapName).each(function() {
            if ($(this).hasClass('selectedStrapOption')) {
                $(this).removeClass('selectedStrapOption');
            }
            if ($(this).hasClass('toggle--active')) {
                $(this).addClass('selectedStrapOption');
            }
        })

        strapStatus(isStrapUnvailable, _this);
    }));

    $(strapName).each(function() {
        if ($(this).hasClass('toggle--active')) {
            $(this).addClass('toggle default-active');
            _strap = $(this).find('.starpcolor-name').text();
            _parent = $(this).parents('.strap-bar__dailog').find('.strap-name');
            $(_parent).html(_strap);
        }
    })

    $(strapCount).each(function() {
        $(this).parents('.product-tile').addClass('overlay');
    })

    $(strapCount).click(function(e) {
        if ($(e.target).closest('.product-tile').length > 0) {
            return false;
        } else {
            if ($('.strap-bar__dailog').hasClass('opacity')) {
                document.body.classList.remove('strap-dialog-overlay');
                $('.product-grid__item').removeClass('index');
                $('.strap-bar__dailog').removeClass('opacity');
                $('.product-tile').removeClass('index strap-view-active');
                $('.window-overlay').removeClass('strap-overlay');
                $('.search-results__toolbar').removeClass('index');
            }
        }
    });

    if ($('.product-grid').hasClass('feed-view')) {
        strapView = 'feed'
    } else {
        strapView = 'grid'
    }
    setTimeout(function() {
        strapCarouselView(strapView);
    }, 2000);
    resetProductAnchors();
}

export function addItemCookie() {
    let productShow = document.querySelectorAll('[data-product-tile]'),
        productShowQuickAdd = document.querySelectorAll('[data-product-url="productShowQuickAdd"]'),
        productShowQuickView = document.querySelectorAll('[data-product-url="productShowQuickView"]');
    let selectorElements = [ productShow, productShowQuickAdd, productShowQuickView ];

    selectorElements.forEach(function(selector) {
        selector.forEach(function(element) {
            element.addEventListener('click', function() {
                let itemId = this.closest('.product-tile').getAttribute('data-tracking-id');
                pushDataLayer(itemId);
            })
        })
    })
}

/**
 * Re-inits all listeners for elements and toggles on the page.
 * @return {[type]} [description]
 */
function _resetElementListeners() {
    setupSortListener();
    setupShowMoreListener();
    setupFiltersListener();
    setupContentTabListener();
    toggleGridFeed();
}

/**
 * Initializes a `popstate`` listener, that is whenever the user uses the browser's navigation arrows.
 * @return {[type]} [description]
 */
export function setupPopListener() {
    window.addEventListener('popstate', function() {
        let searchMain = document.querySelector('[data-search-component="search-main"]'),
            cgid = searchMain.querySelector('[data-cgid]'),
            requestParams = getQueryStringParams(window.location.search);

        //Always attempt to set the category ID if available.
        //This prevents loading into a blank page if SEO friendly URLs are enabled.
        if (cgid) {
            requestParams.cgid = cgid.value;
        }

        _updateResults({
            url: appendParamsToURL(window.SFRA.Urls.searchShowAjax, requestParams),
            event: 'navigation',
            target: searchMain,
            callback: _resetElementListeners
        });
    });
}

/**
 * Initializes sort listener.
 * Leverages Toggle functionality to update the state of toggle.
 * @return {[type]} [description]
 */
export function setupSortListener() {
    let searchMain = document.querySelector('[data-search-component="search-main"]');

    callbackOnElements('[data-search-component="search-sort"]', function(currentSortEl) {
        let sortElAnchors = currentSortEl.querySelectorAll('[data-search-component="search-sort-anchor"]');

        [].forEach.call(sortElAnchors, function(currentSortAnchor) {
            currentSortAnchor.addEventListener('click', _updateResults.bind(currentSortAnchor, {
                target: searchMain,
                event: 'sort',
                updateHTML: true,
                updateHistory: true,
                callback: _resetElementListeners,
                targetFocus: '[data-search-component="search-sort-trigger"]'
            }));
        });
    });
}

// Show more products
export function setupShowMoreListener() {
    let showMoreBtn = document.querySelector('[data-search-component="more-products"]'),
        gridFooter = document.querySelector('[data-search-component="product-grid-footer"]');

    //showMoreBtn is not always present.
    if (showMoreBtn && !showMoreBtn.disabled) {
        let strapView;
        let loadMore = _updateResults.bind(showMoreBtn, {
            target: gridFooter,
            event: 'showMore',
            loadingContainer: showMoreBtn.closest('[data-search-component="product-grid-footer"]'),
            callback: function(response) {
                _updateSortOptions(response);
                toggleHiddenRefinements();
                setupShowMoreListener();
                plpColorStrap();
                widget3DConfiguration();
                if ($('.product-grid').hasClass('feed-view')) {
                    strapView = 'feed'
                } else {
                    strapView = 'grid'
                }
                setTimeout(function() {
                    strapCarouselView(strapView);
                }, 1000);
            }
        });

        showMoreBtn.addEventListener('click', function() {
            updatePageHistory(getNextPageNumber(this));
            loadMore();
        });

        if (window.SFRA.SitePreferences.enableInfiniteScroll) {
            setupInfiniteScroll(showMoreBtn, loadMore);
        }
    }
}

// Handle refinement value selection and reset click
export function setupFiltersListener() {
    let searchMain = document.querySelector('[data-search-component="search-main"]'),
        pageNumberEl = document.querySelector('[data-page-number]'),
        pageNumber = pageNumberEl ? parseInt(pageNumberEl.getAttribute('data-page-number')) : 1,
        refinementActions = document.querySelectorAll('[data-refinement-action]');

    [].forEach.call(refinementActions, function(currentAction) {
        let refinementAction = currentAction.getAttribute('data-refinement-action'),
            refinementID = currentAction.getAttribute('data-refinement-id');

        currentAction.addEventListener('click', _updateResults.bind(currentAction, {
            target: searchMain,
            event: 'refine',
            requestData: { page: pageNumber },
            updateHistory: true,
            callback: _resetElementListeners,
            targetFocus: refinementID ? `[data-refinement-id="${refinementID}"]` : `[data-refinement-type*="${refinementAction}"]`
        }));
    });
}

// Display content results from the search
export function setupContentTabListener() {
    let contentSearchTrigger = document.querySelector('[data-search-component="content-trigger"]'),
        customerCareSearchTrigger = document.querySelector('[data-search-component="customer-care-trigger"]'),
        contenSearchResultsEl = document.querySelector('[data-search-component="content-list"]'),
        customerCareSearchResultsEl = document.querySelector('[data-search-component="customer-care-list"]'),
        showMoreBtn = document.querySelector('[data-search-component="content-more"]');

    if (contentSearchTrigger && contentSearchTrigger.toggle) {
        contentSearchTrigger.toggle.afterSet = function(trigger) {
            if (!trigger.hasAttribute('data-search-content-loaded')) {
                trigger.setAttribute('data-search-content-loaded', true);

                _updateResults.call(trigger, {
                    target: contenSearchResultsEl,
                    updateHTML: true,
                    event: 'contentUpdate'
                });
            }
        };
    }

    if (customerCareSearchTrigger && customerCareSearchTrigger.toggle) {
        customerCareSearchTrigger.toggle.afterSet = function(trigger) {
            if (!trigger.hasAttribute('data-search-content-loaded')) {
                trigger.setAttribute('data-search-content-loaded', true);

                _updateResults.call(trigger, {
                    target: customerCareSearchResultsEl,
                    updateHTML: true,
                    event: 'contentUpdate'
                });
            }
        };
    }

    if (showMoreBtn) {
        showMoreBtn.addEventListener('click', _updateResults.bind(showMoreBtn, {
            target: contenSearchResultsEl,
            appendHTML: true,
            event: 'contentUpdate'
        }));
    }
}

function strapCarouselView(strapView) {
    let productStrap = document.querySelectorAll('[data-strap-carousel]');
    if (productStrap.length > 0) {
        if (strapView === 'feed') {
            $(productStrap).slick('slickSetOption', {
                slidesToShow: 3,
                slidesToScroll: 1
            }, true);
        } else {
            $(productStrap).slick('slickSetOption', {
                slidesToShow: 2,
                slidesToScroll: 1
            }, true);
        }
    }
}

export function resetProductAnchors() {
    let allAnchors = document.querySelectorAll('.product-tile__anchor');
    [].forEach.call(allAnchors, function(currentAnchor) {
        currentAnchor.addEventListener('click', function() {
            window.location = this.href;
        })
    })
}

//Toggle Grid and Feed view
export function toggleGridFeed() {
    let gridFeedToggleEls = document.querySelectorAll('[data-search-component="grid-feed-toggle"]'),
        productGridEl = document.querySelector('[data-search-component="product-grid"]'),
        view;
    [].forEach.call(gridFeedToggleEls, function(gridFeedToggle) {
        gridFeedToggle.addEventListener('click', function() {
            [].forEach.call(gridFeedToggleEls, el => el.classList.remove('set--active'));

            this.classList.add('set--active');

            if (this.dataset.searchLayout === 'feed') {
                view = this.dataset.searchLayout
                productGridEl.classList.add('feed-view');
                strapCarouselView(view);

            } else {
                view = this.dataset.searchLayout
                productGridEl.classList.remove('feed-view');
                strapCarouselView(view);
            }

            if ($('.slick-slider')) {
                $('.slick-slider').slick('setDimensions');
                $('.slick-slider').slick('setPosition');
            }

            updateHistoryState(appendParamsToURL('', { 'toggleGridFeed': this.dataset.searchLayout }, true));
        });
    });
}

export function descriptionMobileTruncate() {
    let plpDescription = document.querySelector('.descriptive-card__description'),
        readMoreBtn = document.querySelector('.read-more-btn.read-more'),
        readLessBtn = document.querySelector('.read-more-btn.read-less');
    if (plpDescription) {
        if ((plpDescription.offsetHeight < plpDescription.scrollHeight) || (plpDescription.offsetWidth < plpDescription.scrollWidth)) {
            readMoreBtn.style.display = 'inline-block';
        } else {
            readMoreBtn.style.display = 'none';
            readLessBtn.style.display = 'none';
        }

        readMoreBtn.addEventListener('click', function() {
            plpDescription.classList.remove('text-line-clamp');
            this.style.display = 'none';
            readLessBtn.style.display = 'inline-block';
        });
        readLessBtn.addEventListener('click', function() {
            plpDescription.classList.add('text-line-clamp');
            this.style.display = 'none';
            readMoreBtn.style.display = 'inline-block';
        });
    }
}

window.addEventListener('resize', descriptionMobileTruncate);

export default {
    setupSort: setupSortListener,
    setupShowMore: setupShowMoreListener,
    setupFilters: setupFiltersListener,
    setupContentTab: setupContentTabListener,
    setupPopListener: setupPopListener,
    toggleGridFeed: toggleGridFeed,
    toggleHiddenRefinements: toggleHiddenRefinements,
    descriptionMobileTruncate: descriptionMobileTruncate,
    widget3DConfiguration: widget3DConfiguration,
    addItemCookie: addItemCookie,
    plpColorStrap: plpColorStrap,
    resetProductAnchors: resetProductAnchors
}
